import { Router } from './router.js';
import { SyncManager } from './sync-manager.js';
import { renderHomeView } from './views/home-view.js';
import { renderScannerView } from './views/scanner-view.js';
import { renderNotasView } from './views/notas-view.js';
import { renderNotaDetailView } from './views/nota-detail-view.js';
import { renderListasView } from './views/listas-view.js';
import { renderListaDetailView } from './views/lista-detail-view.js';
import { renderListaCotacaoView } from './views/lista-cotacao-view.js';
import { renderListaComparativoView } from './views/lista-comparativo-view.js';
import { renderAnaliseView } from './views/analise-view.js';
import { renderLoginView } from './views/login-view.js';
import { renderFamilyView } from './views/family-view.js';
import { renderFeedbackView } from './views/feedback-view.js';
import { renderAdminFeedbackView } from './views/admin-feedback-view.js';
import { renderScannerProductView } from './views/scanner-product-view.js';
import { renderScannerAIView } from './views/scanner-ai-view.js';
import { renderProdutosView } from './views/produtos-view.js';
import { renderLabsView } from './views/labs-view.js';
import { renderLandingView } from './views/landing-view.js';
import { renderManualView } from './views/manual-view.js';
import { initDB } from './db.js';
import { initAnalytics } from './analytics.js';
import { initTheme } from './theme-manager.js';

// Initialize SyncManager
const syncManager = new SyncManager();

// Define App Routes
const routes = {
  landing: (container, param) => renderLandingView(container, syncManager),
  manual: (container, param) => renderManualView(container, syncManager),
  guia: (container, param) => renderManualView(container, syncManager),
  login: (container, param) => renderLoginView(container, param, syncManager),
  home: (container, param) => renderHomeView(container, param, syncManager),
  scanner: (container, param) => renderScannerView(container, param, syncManager),
  labs: (container, param) => renderLabsView(container, syncManager),
  'scanner-produto': (container, param) => renderScannerProductView(container, param, syncManager),
  'scanner-ai': (container, param) => renderScannerAIView(container, param, syncManager),
  produtos: (container, param) => renderProdutosView(container, param, syncManager),
  notas: (container, param) => renderNotasView(container, param, syncManager),
  nota: (container, param) => renderNotaDetailView(container, param, syncManager),
  listas: (container, param) => renderListasView(container, param, syncManager),
  lista: (container, param) => renderListaDetailView(container, param, syncManager),
  'lista-cotacao': (container, param) => renderListaCotacaoView(container, param, syncManager),
  'lista-comparativo': (container, param) => renderListaComparativoView(container, param, syncManager),
  dashboard: (container, param) => renderListasView(container, param, syncManager),
  analise: (container, param) => renderAnaliseView(container, param, syncManager),
  family: (container, param) => renderFamilyView(container, param, syncManager),
  feedback: (container, param) => renderFeedbackView(container, syncManager),
  adminfeedbacks: (container, param) => renderAdminFeedbackView(container, syncManager),
};


// Bootstrap application
async function initApp() {
  initTheme();
  initAnalytics();
  await initDB();
  syncManager.init();

  const router = new Router(routes);
  router.init();

  // Register Service Worker for PWA with auto-update checking
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        // Força checagem imediata por nova versão no servidor
        reg.update().catch(() => {});

        reg.addEventListener('updatefound', () => {
          const installingWorker = reg.installing;
          if (installingWorker) {
            installingWorker.addEventListener('statechange', () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Nova versão instalada com sucesso, recarrega para ativar
                window.location.reload();
              }
            });
          }
        });
      }).catch(err => {
        console.warn('Service Worker registration failed:', err);
      });

      // Recarrega se o Service Worker controller for substituído
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', initApp);
